














































import Vue from "vue";
import { GetI18nStringFromUpdateType, UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { UpdateVersionInfo } from "@/model/data/updates/UpdateVersionInfo";
import { VersionObfuscator } from "@/model/data/updates/VersionObfuscator";

export default Vue.extend({
    data() {
        return {
            UpdateTypeEnum,
        };
    },
    props: {
        sws: Array,
        asws: Array,
        isCustomActionTable: Boolean,
    },
    methods: {
        GetI18nStringFromUpdateType,

        findAvailableSoftwareNotAssociated(sw: UpdateVersionInfo): UpdateVersionInfo {
            return (this.asws as UpdateVersionInfo[]).find((c) => c.updateType == sw.updateType && c.version == sw.version);
        },

        getSoftwareColor(sw: UpdateVersionInfo): string {
            if (this.isCustomActionTable) return "warning";
            if (sw.isUpToDate) {
                if (this.findAvailableSoftwareNotAssociated(sw)) {
                    return "warning";
                } else {
                    return "success";
                }
            } else {
                return "warning";
            }
        },
        getSoftwareIcon(sw: UpdateVersionInfo): string {
            if (this.isCustomActionTable) {
                if (this.findAvailableSoftwareNotAssociated(sw)) return "exclamation-triangle";
                else return "cloud-download-alt";
            }
            if (sw.isUpToDate) {
                if (this.findAvailableSoftwareNotAssociated(sw)) {
                    return "exclamation-triangle";
                } else {
                    return "check";
                }
            } else {
                return "cloud-download-alt";
            }
        },
        getSoftwareTooltipMessage(sw: UpdateVersionInfo): string {
            let type = this.isCustomActionTable ? this.$t("enum.update_type.custom_action") : this.$t("device_update_status.version");
            if (this.isCustomActionTable) {
                const availableSw: UpdateVersionInfo = this.findAvailableSoftwareNotAssociated(sw);
                if (availableSw)
                    return this.$t("device_update_status.available_version_not_associated", { type: type, version: VersionObfuscator.obfuscate(availableSw.availableVersion) });
                else return this.$t("device_update_status.available_version_to_update", { type: type, version: VersionObfuscator.obfuscate(sw.printableAvailableVersion) });
            }
            if (sw.isUpToDate) {
                const availableSw: UpdateVersionInfo = this.findAvailableSoftwareNotAssociated(sw);

                if (availableSw) {
                    return this.$t("device_update_status.available_version_not_associated", { type: type, version: VersionObfuscator.obfuscate(availableSw.availableVersion) });
                } else {
                    return this.$t("device_update_status.up_to_date");
                }
            } else {
                return this.$t("device_update_status.available_version_to_update", { type: type, version: VersionObfuscator.obfuscate(sw.printableAvailableVersion) });
            }
        },
    },
});
